<div class="bar">
  <p class="bar__status" role="status" [class.bar__status--error]="!saving() && (!!error() || (dirty() && !canSave()))">{{ status() }}</p>
  <div class="bar__actions">
    <app-button variant="outline" [disabled]="!dirty() || saving()" (click)="onDiscard()">{{ discardLabel() }}</app-button>
    <app-button class="bar__save" [disabled]="saveDisabled()" (click)="onSave()">
      @if (saving()) {
        <app-inline-spinner aria-hidden="true" />
      } @else {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="m5 12.5 4.5 4.5L19 7.5" />
        </svg>
      }
      {{ saveLabel() }}
    </app-button>
  </div>
</div>
